import { graphql } from 'react-relay';

export default graphql`
  query GrapefulClub_Query {
    viewer {
      id
      ...GrapefulClub_viewer
    }
  }
`;
